import React, {FC, useEffect} from 'react';

import {useInView} from 'react-intersection-observer';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {Price} from 'components/price/price';
import {SALE_CATEGORY_ID} from 'constants/category';

import {isPrescriptionSG} from 'libs/getProductType';
import {ProductDataType} from 'types/recommendationType';

import s from './emptyCartItem.scss';

export type PropsType = {
    productData: ProductDataType;
    sku: string;
    isLastElement: boolean;
    onProductView: (
        product: ProductDataType | ProductDataType[] | [],
        isLastProduct?: boolean,
        sku?: string,
    ) => void;
    onClick: () => void;
};

/**
 * Render product item for recommendation block
 * @returns {React.ReactElement} Rendered react component
 */
export const EmptyCartItem: FC<PropsType> = ({
    isLastElement,
    onClick,
    onProductView,
    productData,
    sku,
}) => {
    const {inView, ref} = useInView({
        threshold: 1,
        triggerOnce: true,
    });

    useEffect(() => {
        if (inView) {
            onProductView(productData, isLastElement, sku);
        }
    }, [inView]);

    const isSale =
        productData.categories.includes(SALE_CATEGORY_ID) &&
        !Number.isNaN(Number(productData.final_price));
    const showLensInfo = productData.isEligibleForRx === 'TRUE';
    const lensesInfo =
        showLensInfo &&
        (isPrescriptionSG(productData.categories) ? 'Prescription eligible' : ' Including lenses');

    return (
        <div className={s.item} ref={ref}>
            <a className={s.link} href={productData.url} onClick={onClick}>
                Go to {productData.name} page
            </a>
            <CloudinaryImage alt={productData.name} className={s.img} src={productData.photoV2} />
            <h3 className={s.name}>{productData.name}</h3>
            <strong className={s.priceHolder}>
                {isSale ? (
                    <>
                        <span className={s.discountedPrice}>
                            <Price>{productData.price}</Price>
                        </span>{' '}
                        <span className={s.finalPrice}>
                            <Price>{productData.final_price}</Price>
                        </span>
                    </>
                ) : (
                    <span>
                        <Price>{productData.price}</Price>
                    </span>
                )}{' '}
                {lensesInfo}
            </strong>
        </div>
    );
};
